import React, { useEffect, useState } from "react";
import Modal from "react-modal";
import { useRecoilValue } from "recoil";
import styled from "styled-components";
import { langState, langText } from "../../recoil/lang";
import "../../styles/CustomModal.css";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import ApiController from "../../controller/ApiController";
import { formatInput } from "../../utils/util";
import { qrAuthState } from "../../recoil/auth";
import { useToast } from "../../controller/ToastController";

const AddCardModal = (oProps: { isVisible: boolean; setVisible: any }) => {
  const queryClient = useQueryClient();
  const showToast = useToast();
  const auth = useRecoilValue(qrAuthState);
  const lang = useRecoilValue(langState);
  const [cardNumber, setCardNumber] = useState<string>("");
  const [expiredDate, setExpiredDate] = useState<string>("");
  const [birthDate, setBirthDate] = useState<string>("");
  const [password, setPassword] = useState<string>("");

  const onChangeCardNumber = (e: any) => {
    setCardNumber(e.target.value);
  };
  const onChangeExpiredDate = (e: any) => {
    setExpiredDate(formatInput(e.target.value));
  };
  const onChangeBirthDate = (e: any) => {
    setBirthDate(formatInput(e.target.value));
  };
  const onChangePassword = (e: any) => {
    setPassword(e.target.value);
  };

  const onCloseModal = () => {
    oProps.setVisible();
    setCardNumber("");
    setExpiredDate("");
    setBirthDate("");
    setPassword("");
  };

  const addCard = useMutation({
    mutationFn: () =>
      ApiController.user.setCard(
        auth.client_user_id,
        expiredDate.split("/", 2)[1],
        expiredDate.split("/", 2)[0],
        birthDate.replace(/\//g, ""),
        cardNumber,
        password
      ),
    onSuccess: (response) => {
      queryClient.invalidateQueries({ queryKey: ["card-list"] });
      console.log("mutation data", response.data.data);
      if (response.data.data.success) {
        onCloseModal();
      } else {
        showToast(response.data.data.message, "error");
      }
    },
  });

  return (
    <Modal
      isOpen={oProps.isVisible}
      onRequestClose={onCloseModal}
      className="languageModal modal-content bottom"
      closeTimeoutMS={100}
      ariaHideApp={false}
    >
      <Style>
        <div className="modal">
          <div className="modal_header">
            <h6>{langText.addCardModal_title[lang]}</h6>
            <img
              className="closeIcon"
              onClick={onCloseModal}
              src={`${process.env.PUBLIC_URL}/knockknock/svg/ic_close.svg`}
              alt="ic"
            />
          </div>
          <div className="modal_content">
            <h5>{langText.addCardModal_card_number[lang]}</h5>
            <input
              value={cardNumber}
              placeholder={langText.addCardModal_placeholder_card_number[lang]}
              onChange={onChangeCardNumber}
              maxLength={16}
            />
            <h5>{langText.addCardModal_expired_date[lang]}</h5>
            <input
              value={expiredDate}
              placeholder="MM/YY"
              onChange={onChangeExpiredDate}
              maxLength={5}
            />
            <h5>{langText.addCardModal_birth_date[lang]}</h5>
            <input
              value={birthDate}
              placeholder="YY/MM/DD"
              onChange={onChangeBirthDate}
              maxLength={8}
            />
            <h5>{langText.addCardModal_password[lang]}</h5>
            <input
              value={password}
              placeholder={langText.addCardModal_placeholder_password[lang]}
              onChange={onChangePassword}
              maxLength={2}
            />
          </div>
          <button className="submitButton" onClick={() => addCard.mutate()}>
            {langText.addCardModal_button_complete[lang]}
          </button>
        </div>
      </Style>
    </Modal>
  );
};

export default AddCardModal;

const Style = styled.div`
  .modal {
    padding: 24px 10px;
    padding-bottom: 40px;
    position: relative;
  }

  .modal_header {
    width: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    h6 {
      font-size: 20px;
      line-height: 30px;
      font-weight: 500;
      color: #ffffff;
    }
    .closeIcon {
      position: absolute;
      width: 24px;
      right: 12px;
      top: 12px;
    }
  }
  .modal_content {
    padding-top: 20px;
    width: 100%;

    h5 {
      font-size: 16px;
      line-height: 22px;
      font-weight: 500;
      margin-bottom: 4px;
    }
    input {
      width: 100%;
      padding: 10px 14px;
      background: #343434;
      border: 1px solid #a7a7a7;
      border-radius: 5px;
      font-size: 14px;
      color: #ffffff;
      margin-bottom: 20px;
      outline-color: #4dd2ae;
    }
    .inputWrap {
      position: relative;
      button {
        position: absolute;
        right: 0;
        background: #343434;
        padding: 7px 10px;
        border-radius: 5px;
        border: 1px solid #4dd2ae;
        h5 {
          font-size: 14px;
          color: #4dd2ae;
          margin: 0;
        }
      }
      p {
        position: absolute;
        top: 12px;
        right: 16px;
        font-size: 14px;
        line-height: 14px;
        font-weight: 600;
        color: #ff4a4a;
      }
    }
  }
  .submitButton {
    width: 100%;
    padding: 12px 0;
    background: #4dd2ae;
    border-radius: 10px;
    color: #ffffff;
    font-size: 20px;
    line-height: 30px;
    font-weight: 600;
  }
`;
